export default {"src":"/_next/static/media/blockscout-logo.d7fd210b.svg","height":24,"width":188,"blurWidth":0,"blurHeight":0};